// extracted by css-extract-rspack-plugin
export default {"forgotPWLink":"_ca7bd25"};